module.exports = __webpack_public_path__ + "img/goverment.25cdcae1.png";